<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="商家账号：" prop="pOperNo">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.pOperNo"
                  filterable
                  remote
                  :remote-method="getUserList"
                >
                  <template v-for="(value, key) in userList">
                    <el-option
                      :key="value.userName"
                      :label="
                        `${value.userName}${
                          value.nickName ? '(' + value.nickName + ')  ' : ''
                        }`
                      "
                      :value="value.userName"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="提现方式：" prop="withdrawMode">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.withdrawMode"
                >
                  <template v-for="(value, key) in dictData['withdraw_mode']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="提现状态：" prop="checkStatus">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.checkStatus"
                >
                  <template v-for="(value, key) in dictData['check_status']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item size="small" label="提现时间：" prop="time">
                <el-date-picker
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="16" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
        :layout="'slot, total, sizes, prev, pager, next, jumper'"
      >
        <!-- <span style="float:left;">
          <el-button
            v-if="auditBtnShow"
            size="small"
            type="success"
            @click="handleOpenAudit"
            >审核
          </el-button>
        </span> -->
      </pagination>
      <el-table :data="tableData">
        <el-table-column label="商家账号" prop="pOperNo"></el-table-column>
        <el-table-column label="提现时间" prop="createTime" width="180">
        </el-table-column>
        <el-table-column label="提现方式" prop="withdrawMode">
          <template slot-scope="scope">
            <span>{{ dictMap["withdraw_mode"][scope.row.withdrawMode] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="银行名称" prop="bankName"></el-table-column>
        <el-table-column label="账号" prop="account"></el-table-column>
        <el-table-column label="姓名" prop="name"></el-table-column>
        <el-table-column label="提现金额" prop="amount"></el-table-column>
        <el-table-column label="充值状态" prop="checkStatus">
          <template slot-scope="scope">
            <span>{{ dictMap["check_status"][scope.row.checkStatus] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核人" prop="auditor"></el-table-column>
        <el-table-column
          label="审核时间"
          prop="auditTime"
          width="180"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="审核意见"
          prop="auditOpinion"
        ></el-table-column>

        <el-table-column width="80px" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.checkStatus === '01'"
              size="small"
              type="text"
              @click="handleOpenAudit(scope.row)"
              >审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="提现审核"
      :visible.sync="dialogVisible"
      destroy-on-close
    >
      <div>
        <el-form
          ref="detailForm"
          :rules="detailFormRules"
          :model="detailForm"
          label-width="140px"
        >
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="商家账号：">
                {{ detailForm.pOperNo }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="提现方式：">
                {{
                  dictMap["withdraw_mode"][detailForm.withdrawMode]
                }}</el-form-item
              >
            </el-col>
            <el-col :span="24">
              <el-form-item label="姓名：">
                {{ detailForm.name }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="支付宝账号：">
                {{ detailForm.account }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="提现金额：">
                {{ detailForm.amount }} 元
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="审核结果：" prop="checkStatus">
                <el-radio-group v-model="detailForm.checkStatus">
                  <el-radio :label="'02'">通过</el-radio>
                  <el-radio :label="'03'">不通过</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="审核意见：">
                <el-input
                  type="textarea"
                  v-model="detailForm.auditOpinion"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleAudit"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import { listWithdraw, updateWithdraw } from "@/api/business/fundManage"
import { listUser } from "@/api/business/merchantManage"

export default {
  components: { Breadcrumb },
  data() {
    return {
      queryParams: {
        pOperNo: undefined,
        withdrawMode: undefined,
        checkStatus: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
        pageSize: 30,
        pageNum: 1,
      },
      total: 0,
      loading: false,
      tableData: [],
      closeDelay: 0,
      currentRow: {},
      auditBtnShow: false,
      detailForm: {},
      dialogVisible: false,
      detailFormRules: {
        checkStatus: [
          { required: true, message: "请选择审核结果！", trigger: "blur" },
        ],
      },
      userList: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  mounted() {
    this.getCache("1")
    this.loadData()
    this.getUserList()
  },
  methods: {
    /* 获取列表数据 */
    async getUserList(query) {
      let pageSize = 10
      if (!query) {
        query = ""
      } else {
        pageSize = 1000
      }
      let result = await listUser({
        pageNum: 1,
        pageSize: pageSize,
        userType: "01",
        userName: query,
      })
      this.userList = result.rows
    },
    loadData() {
      this.setCache("1")
      let _self = this
      this.startLoading()
      _self.queryParams.beginTime = _self.queryParams.time[0]
      _self.queryParams.endTime = _self.queryParams.time[1]
      let params = Object.assign({}, _self.queryParams)
      delete params["time"]
      listWithdraw(params)
        .then((res) => {
          _self.total = res.total
          _self.tableData = res.rows
          this.endLoading()
        })
        .catch((err) => {
          console.error(err)
          this.endLoading()
        })
    },
    resetForm() {
      this.$refs["form"].resetFields()
    },
    handleCurrentChange(val) {
      this.currentRow = val
      if (this.currentRow && this.currentRow.checkStatus === "01") {
        this.auditBtnShow = true
      } else {
        this.auditBtnShow = false
      }
    },
    handleOpenAudit(row) {
      this.detailForm = Object.assign({}, row)
      this.detailForm.checkStatus = "02"
      this.detailForm.auditOpinion = ""
      this.dialogVisible = true
    },
    handleAudit() {
      let _self = this
      if (
        this.detailForm.checkStatus == "03" &&
        this.detailForm.auditOpinion == ""
      ) {
        _self.$message.error("请输入审核意见")
        return
      }
      this.$refs["detailForm"].validate((valid) => {
        if (valid) {
          updateWithdraw(_self.detailForm).then((response) => {
            if (response.code == "200") {
              _self.$message.success("审核成功！")
              _self.dialogVisible = false
              _self.loadData()
            } else {
              _self.$message.error("审核失败！")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
